module.exports = __webpack_public_path__ + "bcf6889142b752b8164641b0af88cbeb.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Work_Sans/WorkSans-Regular.woff2
// module id = 1818
// module chunks = 1